/**
 * @generated SignedSource<<3ddacd7af4b10fc83f110b0a8fcfc2f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EssentialInfoV2_organization$data = {
  readonly location: string | null;
  readonly name: string;
  readonly numberOfIndependentsHired: number;
  readonly url: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "EssentialInfoV2_organization";
};
export type EssentialInfoV2_organization$key = {
  readonly " $data"?: EssentialInfoV2_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"EssentialInfoV2_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EssentialInfoV2_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfIndependentsHired",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "81d4116d19fa5a503dbfb31fc2260048";

export default node;
